var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenuGrants(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.62505,
    y: 1.92193,
    width: 46.1562,
    height: 46.1562,
    rx: 6.07807,
    stroke: "white",
    strokeWidth: 2.15615
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3669 32.638L18.3238 25.8316L11.6289 22.7377L18.3238 19.6439L21.3669 12.8374L24.4101 19.6439L31.1049 22.7377L24.4101 25.8316L21.3669 32.638ZM32.3863 36.2855L30.8807 32.866L27.5173 31.3354L30.8807 29.7722L32.3863 26.3852L33.9238 29.7722L37.2553 31.3354L33.9238 32.866L32.3863 36.2855Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuGrants);
export default __webpack_public_path__ + "static/media/icon_menu_grants.d7d131b01523358ca88c880bccaf3163.svg";
export { ForwardRef as ReactComponent };